import { api } from '@api/api';
import { Action, ThunkAction, combineReducers, configureStore } from '@reduxjs/toolkit';
import appReducer from '@store/app/app.slice';
import cartReducer from '@store/cart/cart.slice';
import catalogReducer from '@store/catalog/catalog.slice';
import dealerReducer from '@store/dealer/dealer.slice';
import devReducer from '@store/dev/dev.slice';
import editReducer from '@store/edit/edit.slice';
import locationReducer from '@store/location/location.slice';
import modalReducer from '@store/modal/modal.slice';
import productReducer from '@store/product/product.slice';
import productsReducer from '@store/products/products.slice';
import searchReducer from '@store/search/search.slice';
import tableReducer from '@store/table/table.slice';
import toastReducer from '@store/toast/toast.slice';
import userReducer from '@store/user/user.slice';
import wishlistReducer from '@store/wishlist/wishlist.slice';
import { translationMiddleware } from '@translations/translations.middleware';

const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  app: appReducer,
  catalog: catalogReducer,
  cart: cartReducer,
  dev: devReducer,
  edit: editReducer,
  modal: modalReducer,
  search: searchReducer,
  product: productReducer,
  wishList: wishlistReducer,
  products: productsReducer,
  user: userReducer,
  toast: toastReducer,
  table: tableReducer,
  dealer: dealerReducer,
  location: locationReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(translationMiddleware).concat(api.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof rootReducer>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
